import { render } from "./add.vue?vue&type=template&id=5ad62107&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=5ad62107&scoped=true&lang=css"

import exportComponent from "F:\\Program\\JAVA\\JavaProject\\DXD物流系统\\logisticsWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad62107"]])

export default __exports__